<template>
  <div class="html">
    <banner
      :title="title"
      :content="content"
    />
    <div class="introduce">
      <p class="sub_title">
        服务方法
      </p>
      <div class="content_A">
        <div>
          【全流量安全监测服务方法】主要依赖于专业安服工程师使用全流量安全监测设备，
          分析设备告警日志， 敏锐的发现真正的攻击行为， 截图并给予说明， 并
          出具可执行改进的分析报告。 <br>
          【分析类型】包括设备状态， 安全态势分析， APT告警， 恶意软件告警，
          网络攻击告警， WebShell告警， 局域网安全分析， 数据库安全分析，
          邮件安全分析，爆破行为分析， 安全事件深度分析等。
        </div>
      </div>
    </div>
    <div class="introduces bg_color">
      <p class="sub_title">
        服务流程
      </p>
      <div class="lists">
        <div
          v-for="(item, index) in processList"
          :key="index"
          class="list_T"
        >
          <div class="item_list1">
            <div class="title">
              {{ item.title }}
            </div>
            <div class="content">
              <div class="content_left1">
                <div>
                  <div>STEP</div>
                  <div>0{{ index + 1 }}</div>
                </div>
              </div>
              <div class="content_right1">
                <div class="content_right_item">
                  <div v-if="item.content">
                    {{ item.content }}
                  </div>
                  <div
                    v-for="list in item.list"
                    :key="list"
                  >
                    <li>{{ list }}</li>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="introduces">
      <p class="sub_title">
        服务价值
      </p>
      <div class="lists">
        <div
          v-for="item in worthList"
          :key="item.id"
          class="list"
        >
          <div class="item_list">
            <div class="img">
              <img
                :src="item.img"
                alt=""
              >
            </div>
            <div class="content">
              <div
                v-for="list in item.list"
                :key="list"
              >
                {{ list }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import banner from '@/views/securityServices/components/banner.vue'
export default {
  name: 'Monitor',
  components: {
    banner
  },
  data() {
    return {
      title: '安全监测服务',
      content:
        '对客户的流量数据进行安全威胁分析，及时发现存在的安全威胁和事件，并提出整改建议。',

      processList: [
        {
          id: 1,
          img: require('@/assets/securityServices/training5.png'),
          title: '前期准备阶段',
          content: '和客户讨论确定单位资产对象。',
          list: ['确定范围', '确定周期', '确定需求']
        },
        {
          id: 2,
          img: require('@/assets/securityServices/training6.png'),
          title: '安全监测实战阶段',
          content: '',
          list: ['信息收集', '监测设备上架', '资产识别', '事件分析']
        },
        {
          id: 3,
          img: require('@/assets/securityServices/training7.png'),
          title: '总结阶段',
          content: '信息整理并形成报告',
          list: []
        }
      ],
      worthList: [
        {
          id: 1,
          img: require('@/assets/securityServices/training1.png'),
          list: ['帮助客户解决问题', '并提高安全防御', '体系']
        },
        {
          id: 2,

          img: require('@/assets/securityServices/training2.png'),
          list: ['检查结果 ”有的', '放矢” 指导安全', '管理及技术体', '系改进']
        },
        {
          id: 3,
          img: require('@/assets/securityServices/training3.png'),
          list: [
            '帮助监督安全管',
            '理制度的落实情',
            '况， 发现违法、 ',
            '违规行为'
          ]
        },
        {
          id: 4,
          img: require('@/assets/securityServices/training4.png'),
          list: ['检查结果作为证', '据，促进安全管', '理考核落地']
        }
      ]
    }
  }
}
</script>
<style scoped>
@import '../../styles/utils.scss';
</style>
<style lang="less" scoped>
.introduces {
  width: 100%;
  margin: 82px auto;

  .title {
    width: 80%;
    margin: 0 auto;
    font-size: 20px;
  }
  .lists {
    width: 70%;
    margin: 0 auto;
    margin-top: 66px;
    display: flex;
    justify-content: space-between;

    .list {
      width: 28%;
      margin-top: 30px;
      margin: 0 1%;
      background: #fff;
      box-shadow: 0 0 50px #ddefff;

      .item_list {
        width: 100%;
        .img {
          text-align: center;
          padding-top: 88px;
          img {
            width: 175px;
            height: auto;
          }
        }
        .content {
          width: 80%;
          margin: 89px auto 133px;

          div {
            text-align: center;
            font-size: 24px;
            font-weight: 400;
            color: #666666;
            line-height: 40px;
          }
        }
      }
    }
    .list_T {
      width: 30%;
      margin-top: 30px;
      margin: 0 1%;
      background: #fff;
      box-shadow: 0 0 50px #ddefff;
      border-radius: 30px;

      .item_list1 {
        width: 100%;
        .title {
          margin-top: 60px;
          font-size: 24px;
          font-weight: bold;
          color: #333333;
          line-height: 40px;
          text-align: center;
        }
        .content {
          width: 100%;
          margin-top: 11px;
          display: flex;
          justify-content: space-between;
          min-height: 300px;

          .content_left1 {
            width: 120px;
            height: 200px;
            background-color: red;
            border-radius: 0 100px 100px 0;
            display: flex;
            align-items: center;
            background: linear-gradient(to bottom, #4d81ea, #72b0f5);
            div {
              display: flex;
              flex-direction: column;
              font-weight: bold;
              color: #ffffff;
              line-height: 40px;
              padding-left: 5px;

              div:nth-child(1) {
                font-size: 28px;
              }
              div:nth-child(2) {
                font-size: 60px;
                margin-top: 5px;
              }
            }
          }
          .content_right1 {
            width: calc(100% - 100px);
            margin-top: 20px;

            .content_right_item {
              text-align: left;
              margin: 0 10%;
              font-size: 20px;
              font-weight: 400;
              color: #666666;
              line-height: 40px;
            }
          }
        }
      }
    }
  }
}
.bg_color {
  background: #fafbff;
  padding: 68px 0 104px;
}
@media (min-width: 1200px)and (max-width: 1350px) {
  .introduce .content_A div{
    font-size: 20px;
  }

  .introduces .lists .list .item_list .content div{
    font-size: 20px;
  }
}
@media (min-width: 1350px)and (max-width: 1500px){
  .introduces .lists .list .item_list .content div{
    font-size: 22px;
  }
}
</style>
